// Convert markdown-like text to HTML
export const convertToHtml = (text) => {
  if (!text) return '';

  let html = text;

  // Convert headings (## Heading)
  html = html.replace(/^## (.+)$/gm, '<h2>$1</h2>');

  // Convert bold (**text**)
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

  // Convert italic (*text*)
  html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');

  // Convert links ([text](url))
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-800 underline">$1</a>');

  // Convert bullet lists
  const bulletListRegex = /(?:^|\n)((?:- .+\n?)+)/g;
  html = html.replace(bulletListRegex, (match, list) => {
    const items = list.trim().split('\n').map(line => {
      const text = line.replace(/^- /, '');
      return `<li>${text}</li>`;
    }).join('');
    return `<ul class="list-disc list-inside my-4">${items}</ul>`;
  });

  // Convert numbered lists
  const numberedListRegex = /(?:^|\n)((?:\d+\. .+\n?)+)/g;
  html = html.replace(numberedListRegex, (match, list) => {
    const items = list.trim().split('\n').map(line => {
      const text = line.replace(/^\d+\. /, '');
      return `<li>${text}</li>`;
    }).join('');
    return `<ol class="list-decimal list-inside my-4">${items}</ol>`;
  });

  // Convert paragraphs (double line breaks)
  const paragraphs = html.split('\n\n').filter(p => p.trim());
  html = paragraphs.map(p => {
    // Don't wrap if already wrapped in tags
    if (p.trim().match(/^<(h\d|ul|ol)/)) {
      return p;
    }
    return `<p>${p.trim()}</p>`;
  }).join('\n');

  return html;
};

// Convert HTML back to markdown-like text for editing
export const convertFromHtml = (html) => {
  if (!html) return '';

  let text = html;

  // Convert headings
  text = text.replace(/<h2>(.+?)<\/h2>/g, '## $1');

  // Convert bold
  text = text.replace(/<strong>(.+?)<\/strong>/g, '**$1**');

  // Convert italic
  text = text.replace(/<em>(.+?)<\/em>/g, '*$1*');

  // Convert links
  text = text.replace(/<a[^>]+href="([^"]+)"[^>]*>([^<]+)<\/a>/g, '[$2]($1)');

  // Convert bullet lists
  text = text.replace(/<ul[^>]*>(.*?)<\/ul>/gs, (match, content) => {
    const items = content.match(/<li>(.+?)<\/li>/g) || [];
    return items.map(item => {
      const text = item.replace(/<\/?li>/g, '');
      return `- ${text}`;
    }).join('\n');
  });

  // Convert numbered lists
  text = text.replace(/<ol[^>]*>(.*?)<\/ol>/gs, (match, content) => {
    const items = content.match(/<li>(.+?)<\/li>/g) || [];
    return items.map((item, index) => {
      const text = item.replace(/<\/?li>/g, '');
      return `${index + 1}. ${text}`;
    }).join('\n');
  });

  // Convert paragraphs
  text = text.replace(/<p>(.*?)<\/p>/g, '$1\n\n');

  // Clean up extra whitespace
  text = text.trim();

  return text;
};
